// extracted by mini-css-extract-plugin
export default {"wrapper":"MainLayout_wrapper__YqWEl","content":"MainLayout_content__eFV6l","collapsed":"MainLayout_collapsed__yIjkN","page":"MainLayout_page__+wG+j"};